'use client';

import React from 'react';
import NewsAskBox from './NewsAskBox';
import NewsStickyCta from './NewsStickyCta';
import NewsTrialDock from './NewsTrialDock';
import { useIsLoggedIn } from './useNewsVisitor';

/**
 * Le due parti dell'articolo che dipendono da chi legge — cioè dal cookie
 * marcatore dell'app, che il server non vede. Tutto il resto della pagina è
 * reso dal server (`NewsArticleView`).
 */

/** Il riquadro «Chiedilo» della colonna: senza la CTA principale per chi non ha un account, che ha il dock. */
export const NewsSidebarAskBox = ({ slug, questions }: { slug: string; questions: string[] }) => {
  const isLoggedIn = useIsLoggedIn();
  return (
    <NewsAskBox
      slug={slug}
      questions={questions}
      position="sidebar"
      variant="compact"
      withoutMainCta={!isLoggedIn}
    />
  );
};

/** Chi ha un account ha la barra che porta al quesito; gli altri il dock della prova. */
export const NewsBottomCta = ({ slug }: { slug: string }) => {
  const isLoggedIn = useIsLoggedIn();
  return isLoggedIn ? <NewsStickyCta slug={slug} /> : <NewsTrialDock slug={slug} />;
};
